import { useDocumentForEsigning } from 'app/domains/esigning/hooks/useDocumentForEsigning';
import { useEsigningProviders } from 'app/domains/esigning/hooks/useEsigningProviders';
import { useEsigningRecipients } from 'app/domains/esigning/hooks/useEsigningRecipients';
import { useGetSignRequestAttachments } from 'app/domains/esigning/hooks/useGetSignRequestAttachments';
export function useEsigningLoadingState() {
    const { loading: loadingRecipients } = useEsigningRecipients();
    const { loading: loadingDocumentSupport } = useDocumentForEsigning();
    const { loading: loadingAttachments } = useGetSignRequestAttachments();
    const { loading: loadingEsigningProviders } = useEsigningProviders();
    return loadingRecipients || loadingDocumentSupport || loadingEsigningProviders || loadingAttachments;
}
